export enum BlindMatchStatus {
  Loading = 'loading',
  // Brief debounced state shown while the user is actively typing, before
  // the match check runs against the resolved source. Distinct from
  // Loading (which means "source is being fetched").
  Validating = 'validating',
  Precheck = 'precheck',
  Failed = 'failed',
  Verified = 'verified',
  // The typed value did NOT match the source, but an override has been
  // engaged with a reason. Replaces Failed in the badge so the field
  // doesn't keep reading as broken once the user has approved the
  // override.
  Overridden = 'overridden',
  Unavailable = 'unavailable',
  FetchError = 'fetchError',
}

export interface BlindMatchUserEdge {
  entityId: string
  displayName?: string
}

export interface BlindMatchValue {
  value?: string
  verified?: boolean
  overridden?: boolean
  overrideReason?: string
  overriddenBy?: {
    user?: BlindMatchUserEdge
  }
}

export type StatusTooltipOverrides = Partial<Record<BlindMatchStatus, string>>
